import {
  object as YupObject,
  string as YupString,
  array as YupArray,
  boolean as YupBoolean
} from 'yup';

import { actions } from 'app-constants';

const fieldKey = YupString()
  .required()
  .min(5)
  .max(30)
  .matches(
    new RegExp(/^[a-zA-Z0-9_-]*$/i),
    'Feature key must be in alphanumeric w/ underscore or hyphen and without space.'
  )
  .strict(true)
  .label('Feature Key');

const fieldDescription = YupString().max(200).label('Feature Description');

const fieldCondition = YupArray().of(
  YupObject().shape({
    enable: YupBoolean(),
    conditionTarget: YupString().when(
      ['conditionType', 'enable'],
      (conditionType, enable, schema) => {
        if (enable && conditionType === 'TARGET_USER') {
          return schema
            .matches(
              new RegExp(/^(?!NONE$).*$/i),
              'User Segment is a required field.'
            )
            .strict(true)
            .label('User Segment');
        }

        if (enable && conditionType === 'TARGET_APP_VERSION') {
          return schema
            .required()
            .matches(
              new RegExp(/^\s*(\d+\.)?(\d+\.)?(\*|\d+)\s*$/i),
              'App version must be in version.release.modification format.'
            )
            .strict(true)
            .label('App Version');
        }

        return schema;
      }
    )
  })
);

export default function prepareValidationSchema(action) {
  const validationObjectShape = {};

  if (action === actions.FEATURE_ADD) {
    validationObjectShape.key = fieldKey;
    validationObjectShape.description = fieldDescription;
  } else if (action === actions.FEATURE_EDIT) {
    validationObjectShape.description = fieldDescription;
    validationObjectShape.conditions = fieldCondition;
  }

  const validationSchema = YupObject().shape(validationObjectShape);
  return validationSchema;
}
